/**
 * Cdn Icon Formatter.
 * @param {*} value
 * @param {Object} row
 * @returns {String|*}
 */
window.cdnIconFormatter = function(value, row) {
    if (row.original_type == "directory") {
        return '<i class="fal fa-folder text-muted"></i>';
    }
    let extensions = ["png", "jpg", "jpeg", "gif"];
    if (extensions.includes(row.extension)) {
        return '<i class="fal fa-file-image text-muted"></i>';
    }
    return '';
};
